import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-surface)'
  }} data-id="element-157">
      <div className="max-w-2xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-159">
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-8" style={{
          background: 'rgba(78,205,196,0.1)',
          border: '2px solid var(--color-accent)'
        }} data-id="element-160">
            <ShieldCheckIcon className="w-10 h-10" style={{
            color: 'var(--color-accent)'
          }} data-id="element-161" />
          </div>

          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-162">
            Riesgo cero
          </p>

          <h2 className="text-3xl md:text-4xl font-black mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-163">
            La Decisión Fácil
          </h2>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-164">
            Crecimiento AudioPro está diseñado para que la primera experiencia
            ya cambie algo en ti.
          </p>

          <p className="text-lg leading-relaxed mb-10" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-165">
            No prometemos transformación instantánea. Prometemos algo más
            honesto:
          </p>

          <div className="py-8 px-8 mb-10 rounded-sm" style={{
          background: '#0f0f0f',
          border: '1px solid var(--color-accent)'
        }} data-id="element-166">
            <p className="text-xl md:text-2xl italic leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-167">
              "El primer recurso que consumas te va a dar más claridad aplicable
              que los últimos tres libros de autoayuda que leíste."
            </p>
          </div>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-168">
            Si eso no ocurre, tienes{' '}
            <strong style={{
            color: 'var(--color-text)'
          }} data-id="element-169">
              garantía completa respaldada por Hotmart.
            </strong>
          </p>

          <p className="text-lg leading-relaxed mb-10" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-170">
            Sin preguntas. Sin procesos complicados.
          </p>

          <div className="py-5 px-8 rounded-sm inline-block" style={{
          background: 'rgba(78,205,196,0.08)',
          border: '1px solid var(--color-accent)'
        }} data-id="element-171">
            <p className="text-lg font-bold" style={{
            color: 'var(--color-accent)'
          }} data-id="element-172">
              La única forma de perder aquí es no empezar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}